"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STATE_FONT_SIZE_RATIO = exports.MAP_BOTTOM_GAP_SIZE = exports.MAP_TOP_GAP_SIZE = exports.CHART_PADDING = void 0;
/* eslint-disable camelcase */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-nested-ternary */
const styles_1 = require("@material-ui/core/styles");
const color_1 = __importDefault(require("color"));
const d3_1 = require("d3");
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const Cartogram_1 = __importStar(require("../../components/Cartogram"));
const ChartWrapper_1 = __importStar(require("../../components/ChartWrapper"));
const Footnotes_1 = require("../../components/Footnotes");
const Scale_1 = __importDefault(require("../../components/Scale"));
const helpers_1 = require("../../components/Scale/helpers");
const Sources_1 = require("../../components/Sources");
const Tooltip_1 = __importDefault(require("../../components/Tooltip"));
const TooltipContent_1 = __importDefault(require("../../components/Tooltip/TooltipContent"));
const utilities_1 = require("../../utilities");
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const date_1 = require("../../utilities/date");
const measurements_1 = require("../../utilities/measurements");
const types_1 = require("../../utilities/types");
const usStates_1 = __importDefault(require("../../utilities/usStates"));
const constants_2 = require("../LineChart/constants");
const constants_3 = require("./constants");
exports.CHART_PADDING = 10;
exports.MAP_TOP_GAP_SIZE = 20;
exports.MAP_BOTTOM_GAP_SIZE = 20;
exports.DEFAULT_STATE_FONT_SIZE_RATIO = 1 / 500;
const MINIMUM_HEX_FONT_SIZE = 8;
const Cartogram = _ref => {
  var _Object$values, _Object$values2, _Object$values3, _Object$values4, _Object$values5, _Object$values6;
  let {
    titleOptions = constants_3.DEFAULT_TITLE_OPTIONS,
    subtitleOptions = constants_3.DEFAULT_SUBTITLE_OPTIONS,
    data: rawData,
    dataSeriesOptions: rawDataSeriesOptions = [],
    footerOptions = constants_3.DEFAULT_FOOTER_OPTIONS,
    height,
    width,
    hexLabelFontSize,
    fontWeight = 400,
    backgroundColor = 'usa-gray',
    tooltipOptions = constants_3.DEFAULT_TOOLTIP_OPTIONS,
    scaleOptions = constants_3.DEFAULT_SCALE_OPTIONS,
    keyType,
    strokeColor,
    strokeWidth = 2,
    spacing = 4,
    showUSA = false,
    makeUSABigger = true,
    dropdownOptions = constants_3.DEFAULT_DROPDOWN_OPTIONS
  } = _ref;
  /* eslint-disable react-hooks/exhaustive-deps */
  const footerOptionsValues = (_Object$values = Object.values(footerOptions)) === null || _Object$values === void 0 ? void 0 : _Object$values.join();
  const optsFooter = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, footerOptions, constants_3.DEFAULT_FOOTER_OPTIONS), [footerOptionsValues]);
  const subtitleOptionsValues = (_Object$values2 = Object.values(subtitleOptions)) === null || _Object$values2 === void 0 ? void 0 : _Object$values2.join();
  const optsSubtitle = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, subtitleOptions, constants_3.DEFAULT_SUBTITLE_OPTIONS), [subtitleOptionsValues]);
  const titleOptionsValues = (_Object$values3 = Object.values(titleOptions)) === null || _Object$values3 === void 0 ? void 0 : _Object$values3.join();
  const optsTitle = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, titleOptions, constants_3.DEFAULT_TITLE_OPTIONS), [titleOptionsValues]);
  const tooltipOptionsValues = (_Object$values4 = Object.values(tooltipOptions)) === null || _Object$values4 === void 0 ? void 0 : _Object$values4.join();
  const optsTooltip = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, tooltipOptions, constants_3.DEFAULT_TOOLTIP_OPTIONS), [tooltipOptionsValues]);
  const theme = (0, styles_1.useTheme)();
  const MIN_HEIGHT = window.screen.width < theme.breakpoints.values.lg ? 200 : 400;
  const dropdownOptionsValues = (_Object$values5 = Object.values(dropdownOptions)) === null || _Object$values5 === void 0 ? void 0 : _Object$values5.join();
  const optsDropdown = (0, react_1.useMemo)(() => {
    const options = lodash_1.default.defaultsDeep({}, dropdownOptions, constants_3.DEFAULT_DROPDOWN_OPTIONS);
    return {
      ...options,
      selectedItem: options.selectedItem ? String(options.selectedItem) : undefined
    };
  }, [dropdownOptionsValues]);
  const scaleOptionsValues = (_Object$values6 = Object.values(scaleOptions)) === null || _Object$values6 === void 0 ? void 0 : _Object$values6.join();
  const optsScale = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, scaleOptions, constants_3.DEFAULT_SCALE_OPTIONS), [scaleOptionsValues]);
  /* eslint-enable react-hooks/exhaustive-deps */
  if (!rawData || !rawData.datasets || !rawData.datasets.length) {
    return null;
  }
  const data = (0, utilities_1.extractStateDatasets)(rawData);
  if (!data.datasets) {
    return null;
  }
  const dataSeriesOptions = (0, utilities_1.prepareDataSeriesOptions)(data.datasets, rawDataSeriesOptions, 'geo_id');
  const validFipsList = showUSA ? [...usStates_1.default.map(_ref2 => {
    let {
      fips
    } = _ref2;
    return fips;
  }), 'US'] : usStates_1.default.map(_ref3 => {
    let {
      fips
    } = _ref3;
    return fips;
  });
  data.datasets = data.datasets.filter(_ref4 => {
    let {
      geo_id
    } = _ref4;
    return validFipsList.includes(geo_id);
  });
  const {
    text: titleText,
    fontSize: titleFontSize = ChartWrapper_1.DEFAULT_TITLE_FONT_SIZE
  } = optsTitle || {};
  const {
    text: subtitleText,
    fontSize: subtitleFontSize = ChartWrapper_1.DEFAULT_SUBTITLE_FONT_SIZE
  } = optsSubtitle || {};
  const {
    show: showTooltip = true,
    showSubtitle: showTooltipSubtitle = true,
    color: tooltipColor = 'scale-darkest',
    decimals: tooltipDecimals
  } = optsTooltip;
  const {
    colorScale = constants_3.DEFAULT_COLOR_SCALE,
    reverseColorOrder = false,
    fontColor,
    values = [],
    centeredScale = false,
    floatingScale = false,
    fontSize: scaleFontSize = constants_1.DEFAULT_FONT_SIZE
  } = optsScale;
  const {
    enabled: enableDropdown = true,
    selectedItem,
    show: showDropdown = true,
    sort: sortDropdown = true,
    type: dropdownType
  } = optsDropdown || {};
  const {
    sources: chartSources,
    footnotes: chartFootnotes,
    show: showFooter = true,
    fontSize: footerFontSize = constants_1.DEFAULT_FONT_SIZE
  } = optsFooter || {};
  let cartogramColorScale = colorScale.slice().map((colorString, i) => (0, colors_1.parseColor)(colorString, constants_3.DEFAULT_COLOR_SCALE[i % constants_3.DEFAULT_COLOR_SCALE.length]));
  if (Array.isArray((0, colors_1.parseColor)(colorScale[0], undefined))) {
    cartogramColorScale = (0, colors_1.parseColor)(colorScale[0], undefined);
  }
  if (reverseColorOrder) {
    cartogramColorScale.reverse();
  }
  const getScaleTypeFromData = scaleData => {
    const type = scaleData.datasets[0].y_type;
    return (0, utilities_1.isValidAxisType)(type) ? type : constants_2.DEFAULT_Y_TYPE;
  };
  const validScaleType = (0, utilities_1.isValidAxisType)(keyType) ? keyType : getScaleTypeFromData(data);
  const scaleFormatter = (0, utilities_1.valueFormat)({
    params: {
      format: validScaleType
    }
  });
  let validDropdownType = (0, utilities_1.isValidAxisType)(dropdownType) ? dropdownType : (0, utilities_1.getAxisTypeFromData)(data.datasets, 'x');
  if (!validDropdownType) {
    validDropdownType = 'unformatted';
  }
  const dropdownFormatter = (0, utilities_1.valueFormat)({
    params: {
      format: validDropdownType
    }
  });
  const dropDownKeys = (0, lodash_1.default)(data.datasets).map(_ref5 => {
    let {
      data: innerData
    } = _ref5;
    return innerData.map(_ref6 => {
      let {
        key
      } = _ref6;
      return {
        key,
        formatted: (0, date_1.dateParser)(key, validDropdownType)
      };
    });
  }).flatMap().uniqBy(_ref7 => {
    let {
      key
    } = _ref7;
    return key;
  }).map(entry => ({
    ...entry,
    parsed: dropdownFormatter(entry.key)
  })).value();
  const {
    key: selected,
    dropdown
  } = (0, utilities_1.useDropdown)({
    enabled: enableDropdown,
    keys: dropDownKeys,
    label: titleText ? ' ' : '',
    parser: dropdownFormatter,
    sortBy: sortDropdown,
    targetKey: selectedItem
  });
  const includedValues = data.datasets.map(_ref8 => {
    let {
      data: innerData
    } = _ref8;
    return innerData.map(_ref9 => {
      let {
        value,
        key
      } = _ref9;
      if (!floatingScale || key === selected) {
        return value;
      }
      return undefined;
    });
  }).flat().filter(value => value !== undefined);
  const showScaleNoData = validFipsList.some(fipsKey => {
    const subDataArray = data.datasets.find(entry => entry.geo_id === fipsKey);
    if (!subDataArray || !subDataArray.data) {
      return true;
    }
    return dropDownKeys.some(_ref10 => {
      let {
        key: dropKey
      } = _ref10;
      if (!floatingScale || dropKey === selected) {
        const subEntry = subDataArray.data.find(_ref11 => {
          let {
            key
          } = _ref11;
          return key === dropKey;
        });
        if (!subEntry || !subEntry.value) {
          return true;
        }
      }
      return false;
    });
  });
  const maxAbsValue = Math.max(...includedValues.map(value => Math.abs(value)));
  const maximum = centeredScale ? maxAbsValue : Math.max(...includedValues);
  const minimum = centeredScale ? -maxAbsValue : Math.min(...includedValues);
  const scaleValues = values.length > 1 ? values : (0, helpers_1.createScaleValues)(cartogramColorScale.length, minimum, maximum);
  const filteredData = data.datasets.map(_ref12 => {
    let {
      geo_id,
      data: dataArray
    } = _ref12;
    const {
      value
    } = dataArray.filter(_ref13 => {
      let {
        key
      } = _ref13;
      return key === selected;
    })[0] ? dataArray.filter(_ref14 => {
      let {
        key
      } = _ref14;
      return key === selected;
    })[0] : {};
    const hexBackgroundColor = (0, helpers_1.getScaleColor)(value, scaleValues, cartogramColorScale);
    const {
      strokeColor: hexStrokeColor,
      strokeWidth: hexStrokeWidth
    } = lodash_1.default.find(dataSeriesOptions, {
      geo_id
    }) || {};
    return {
      fips: geo_id || '00',
      backgroundColor: hexBackgroundColor,
      fontColor: (0, color_1.default)(hexBackgroundColor).isDark() ? '#FFFFFF' : '#212121',
      strokeColor: (0, colors_1.parseColor)(hexStrokeColor, strokeColor || hexBackgroundColor),
      strokeWidth: hexStrokeWidth || strokeWidth
    };
  });
  const [tooltip, setTooltip] = (0, react_1.useState)({
    position: {
      x: null,
      y: null
    },
    value: undefined,
    title: '',
    subtitle: '',
    color: 'usa-gray',
    type: validScaleType
  });
  const moveTooltip = (event, fips) => {
    if (!event) {
      setTooltip({
        position: {
          x: null,
          y: null
        },
        value: undefined,
        title: '',
        subtitle: '',
        color: 'usa-gray',
        type: validScaleType
      });
    } else {
      const stateData = data.datasets.filter(_ref15 => {
        let {
          geo_id
        } = _ref15;
        return geo_id === fips;
      })[0];
      const value = stateData ? stateData.data.filter(_ref16 => {
        let {
          key
        } = _ref16;
        return key === selected;
      })[0] ? stateData.data.filter(_ref17 => {
        let {
          key
        } = _ref17;
        return key === selected;
      })[0].value : null : null;
      const getDarkestColor = darkColorScale => {
        const lightnesses = darkColorScale.map(color => (0, d3_1.hsl)(color).l);
        return darkColorScale[lightnesses.indexOf(Math.min(...lightnesses))];
      };
      const getTooltipColor = () => {
        const customColor = tooltipColor || 'scale-darkest';
        if (value === null || value === undefined) {
          return (0, colors_1.parseColor)('usa-gray');
        }
        switch (customColor) {
          case 'scale-min':
            return cartogramColorScale[0];
          case 'scale-max':
            return cartogramColorScale[scaleValues.length - 2];
          case 'scale-extents':
            return (0, helpers_1.getExtentColor)(value, scaleValues, cartogramColorScale);
          case 'scale-darkest':
            return getDarkestColor(cartogramColorScale);
          default:
            return (0, colors_1.parseColor)(customColor, 'usa-gray');
        }
      };
      const getStateNameFromFips = fipsToFind => {
        var _usStates_1$default$f;
        if (fipsToFind === 'US') {
          return 'US';
        }
        return ((_usStates_1$default$f = usStates_1.default.find(_ref18 => {
          let {
            fips: stateFips
          } = _ref18;
          return stateFips === fipsToFind;
        })) === null || _usStates_1$default$f === void 0 ? void 0 : _usStates_1$default$f.name) || '';
      };
      let tooltipX = null;
      let tooltipY = null;
      if (event.target && event.target.nodeName === 'polygon' && event.target.points) {
        Array.from(event.target.points).forEach(_ref19 => {
          let {
            x,
            y
          } = _ref19;
          tooltipX += x;
          tooltipY += y;
        });
        tooltipX /= event.target.points.length;
        tooltipY /= event.target.points.length;
      }
      const {
        tooltipTitle: stateTitle
      } = lodash_1.default.find(dataSeriesOptions, {
        geo_id: fips
      }) || {};
      setTooltip({
        position: {
          x: tooltipX || tooltip.position.x || 0,
          y: tooltipY || tooltip.position.y || 0
        },
        value: value ?? null,
        title: stateTitle || getStateNameFromFips(fips),
        subtitle: dropdownFormatter(selected) || selected,
        color: getTooltipColor(),
        type: stateData && (0, utilities_1.isValidAxisType)(stateData.y_type) ? stateData.y_type : validScaleType
      });
    }
  };
  const dataArray = [data];
  const {
    sources: footerSources,
    summary: footerSummary
  } = showFooter ? (0, Sources_1.useSources)({
    data: dataArray,
    chartSources
  }) : {
    sources: [],
    summary: ''
  };
  const {
    footnotes
  } = showFooter ? (0, Footnotes_1.useFootnotes)({
    dataArray,
    chartFootnotes
  }) : {
    footnotes: []
  };
  return react_1.default.createElement(ChartWrapper_1.default, {
    className: "cartogram-chart",
    title: titleText,
    subtitle: subtitleText,
    titleFontSize: titleFontSize,
    subtitleFontSize: subtitleFontSize,
    footerSources: footerSources,
    footerSummary: footerSummary,
    footnotes: footnotes,
    showFooter: showFooter,
    dropdowns: showDropdown && dropdown ? [dropdown] : [],
    height: height || undefined,
    width: width || undefined,
    fontSize: footerFontSize,
    onMouseLeave: () => moveTooltip()
  }, _ref20 => {
    let {
      chartWidth
    } = _ref20;
    const scaleHeight = optsScale.height + optsScale.fontSize * 1.5;
    const {
      height: mapHeight,
      width: mapWidth
    } = (0, measurements_1.getMapDimensions)(Cartogram_1.USA_MAP_WIDTH_HEIGHT_RATIO, chartWidth, height > 0 ? Math.max(height, MIN_HEIGHT) : null);
    const minMapHeight = Math.max(mapHeight, MIN_HEIGHT);
    const minChartHeight = minMapHeight + scaleHeight + exports.MAP_TOP_GAP_SIZE + exports.MAP_BOTTOM_GAP_SIZE;
    const hexFontSize = hexLabelFontSize ?? Math.max(Math.round(exports.DEFAULT_STATE_FONT_SIZE_RATIO * mapWidth * constants_3.DEFAULT_HEX_LABEL_FONT_SIZE), MINIMUM_HEX_FONT_SIZE);
    const cartogram = react_1.default.createElement(Cartogram_1.default, {
      data: filteredData,
      strokeColor: strokeColor,
      strokeWidth: strokeWidth,
      fontSize: hexFontSize,
      fontWeight: fontWeight,
      spacing: spacing,
      backgroundColor: backgroundColor,
      height: mapHeight,
      width: mapWidth,
      showUSA: showUSA,
      makeUSABigger: makeUSABigger,
      onMouseOver: (event, fips) => moveTooltip(event, fips)
    });
    const scale = scaleValues.length > 1 && react_1.default.createElement(Scale_1.default, {
      colorScale: cartogramColorScale,
      values: scaleValues,
      fontColor: fontColor,
      fontSize: scaleFontSize,
      width: optsScale.width || mapWidth * 4 / 5,
      height: optsScale.height,
      x: optsScale.x || mapWidth / 10,
      y: optsScale.y || minMapHeight + scaleHeight,
      formatter: scaleFormatter,
      showNoData: showScaleNoData,
      noDataColor: "usa-gray"
    });
    return react_1.default.createElement("div", {
      style: {
        minHeight: minChartHeight,
        position: 'relative'
      }
    }, react_1.default.createElement("div", {
      style: {
        height: exports.MAP_TOP_GAP_SIZE
      }
    }), react_1.default.createElement("svg", {
      style: {
        overflow: 'visible'
      },
      className: "cartogram-svg"
    }, react_1.default.createElement("g", {
      width: mapWidth,
      height: mapHeight,
      className: "cartogram-g"
    }, cartogram), scaleValues.length > 1 && scale), showTooltip !== false && tooltip.position.x !== null && tooltip.position.y !== null && react_1.default.createElement("div", {
      className: "tooltip-container"
    }, react_1.default.createElement(Tooltip_1.default, {
      x: tooltip.position.x,
      y: tooltip.position.y,
      direction: "above",
      width: chartWidth
    }, react_1.default.createElement(TooltipContent_1.default, {
      title: tooltip.title,
      subtitle: showTooltipSubtitle ? tooltip.subtitle : undefined,
      value: tooltip.value,
      color: tooltip.color,
      decimals: tooltipDecimals,
      type: tooltip.type
    }))));
  });
};
Cartogram.propTypes = {
  /** Layout */
  ...ChartWrapper_1.chartWrapperPropTypes,
  /**
   * Title parameters for the cartogram.
   * @param text Title text.
   * @param fontSize Title font size.
   */
  titleOptions: (0, prop_types_1.shape)({
    text: prop_types_1.string,
    fontSize: prop_types_1.number
  }),
  /**
   * Subtitle parameters for the cartogram.
   * @param text Subtitle text
   * @param fontSize Subtitle font size.
   */
  subtitleOptions: (0, prop_types_1.shape)({
    text: prop_types_1.string,
    fontSize: prop_types_1.number
  }),
  /**
   * Data for the cartogram.
   * @param datasets State data entries.
   * Each entry contains a required geo_id (number) which is the fips code used to id the state,
   * and a required data array with key/value pairs.
   * Each entry can also have an optional x_type (string) used to parse keys for sorting,
   * and an optional y_type (string) used for tooltip value formatting.
   * @param sources Data sources in the standard format. (see chartSources for structure)
   */
  data: (0, prop_types_1.shape)({
    /** State data entires */
    datasets: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
      /** Fips code used to id the state. Entries with invalid fips codes are ignored. */
      geo_id: prop_types_1.string.isRequired,
      /** Custom type used to id key type for sorting purposes */
      x_type: prop_types_1.string,
      /** Custom type used for tooltip formatting */
      y_type: prop_types_1.string,
      /** State data */
      data: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
        /** Dropdown category */
        key: prop_types_1.string.isRequired,
        /** Value for the state/category combination */
        value: prop_types_1.number
      })).isRequired
    })).isRequired,
    /** Data sources */
    sources: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.sourcesShape))
  }).isRequired,
  /**
   * Array of state-specific visual changes.
   * @param geo_id Required fips code to id the state.
   * @param tooltipTitle Tooltip title override for the state.
   * @param strokeWidth Custom stroke width for state border.
   * @param strokeColor Custom stroke color for state border.
   */
  dataSeriesOptions: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    geo_id: prop_types_1.string.isRequired,
    tooltipTtile: prop_types_1.string,
    strokeWidth: prop_types_1.number,
    strokeColor: prop_types_1.string
  })),
  /**
   * Configuration options for footer
   * @param fontSize {number} font size override of footer text
   * @param footnotes {object[]} footnotes to add to those found in the data
   * @param show {bool} is footer shown
   * @param sources {object[]} sources to add to those found in the data   *
   */
  footerOptions: (0, prop_types_1.shape)({
    fontSize: prop_types_1.number,
    footnotes: ChartWrapper_1.chartWrapperPropTypes.footnotes,
    show: ChartWrapper_1.chartWrapperPropTypes.showFooter,
    sources: ChartWrapper_1.chartWrapperPropTypes.footerSources
  }),
  /** height for the chart. */
  height: prop_types_1.number,
  /** Width for the chart. */
  width: prop_types_1.number,
  /**
   * Font size for hex labels.
   * Font scales linearly with width, and this is
   * set so that the entred font size appears when width = 500px.
   */
  hexLabelFontSize: prop_types_1.number,
  /** Font weight for cartogram labels */
  fontWeight: prop_types_1.number,
  /** Default background color for states without data. */
  backgroundColor: prop_types_1.string,
  /**
   * Options for tooltips.
   * @param decimals Sets the number of decimal places in tooltip value.
   * @param showSubtitle Shows/hides subtitle.
   * @param showTooltip Enables/disables tooltip.
   * @param color Sets custom color for tooltip.
   * Can be set to a specific color or to one of the following control values (strings):
   * 'scale-min': minimum scale color.
   * 'scale-max': maximum scale color.
   * 'scale-extents': sets to the max/min scale color with
   *   scale section closest to that of the hovered state.
   *   (sets color to #212121 if the value is in the central scale section).
   * 'scale-darkest': sets to the color of the scale with lowest lightness.
   */
  tooltipOptions: (0, prop_types_1.shape)({
    decimals: prop_types_1.number,
    showSubtitle: prop_types_1.bool,
    show: prop_types_1.bool,
    color: prop_types_1.string
  }),
  /**
   * Options for the scale.
   * @param colorScale Sets colors for the cartogram.
   * Either an array of custom scale colors or a one cell
   * array containing the string name of a supported color scale.
   * @param reverseColorOrder Reverses order of colorScale.
   * @param fontColor Sets scale label color.
   * @param width Sets scale width in px.
   * @param height Sets scale height in px.
   * @param x Sets x coordinate of scale.
   * @param y Sets y coordinate of scale.
   * @param values Custom values for scale (same for all dropdowns).
   * @param centeredScale Forces automatically generated scale to have
   *  max/min values of equal absoute value, centered around 0.
   * @param floatingScale Makes the scale only span the values for the selected key.
   * @param fontSize font size for scale labels
   */
  scaleOptions: (0, prop_types_1.shape)({
    colorScale: (0, prop_types_1.arrayOf)(prop_types_1.string),
    reverseColorOrder: prop_types_1.bool,
    fontColor: prop_types_1.string,
    width: prop_types_1.number,
    height: prop_types_1.number,
    x: prop_types_1.number,
    y: prop_types_1.number,
    values: (0, prop_types_1.arrayOf)(prop_types_1.number),
    centeredScale: prop_types_1.bool,
    floatingScale: prop_types_1.bool,
    fontSize: prop_types_1.number
  }),
  /** Custom type used for scale/tooltip value formatting.
   * If undefined, this defaults to data.datasets[0].y_type.
   */
  keyType: prop_types_1.string,
  /** Sets border color around each hex */
  strokeColor: prop_types_1.string,
  /** Sets border width around each hex */
  strokeWidth: prop_types_1.number,
  /** Sets spacing between states. */
  spacing: prop_types_1.number,
  /** Shows/hides US Hex. */
  showUSA: prop_types_1.bool,
  /** Makes USA bigger (if shown). */
  makeUSABigger: prop_types_1.bool,
  /** Options for the dropdown.
   * @param enabled Allows selected item to be changed.
   * @param selectedItem Default value for dropdown. Must match a valid key in data.
   * @param show Shows/hides dropdown.
   * @param type Custom type used for dropdown formatting.
   * (Check keyType for list of valid types)
   */
  dropdownOptions: (0, prop_types_1.shape)({
    enabled: prop_types_1.bool,
    selectedItem: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
    show: prop_types_1.bool,
    sort: (0, prop_types_1.oneOfType)([prop_types_1.bool, (0, prop_types_1.oneOf)(['ascending', 'descending'])]),
    type: prop_types_1.string
  })
};
exports.default = Cartogram;